import { AddIcon, RestaurantIcon } from "../../components/icons";
import { ProductName, ProductPrice } from "../../components/ProductsList";
import useGoTo from "../../hooks/useGoTo";
import useCartUpsell from "../../hooks/useCartUpsell";

// O totem não adiciona direto pelo "+" (useQuickAdd): aparelho compartilhado,
// o produto sempre passa pela tela dele.
const noQuickAdd = () => false;

/**
 * "Peça também" na sacola do totem: as mesmas sugestões do celular
 * (useCartUpsell), numa faixa de cartões grandes que rola para o lado. O
 * cartão inteiro é o botão e abre o produto; o "+" só sinaliza.
 */
export default function CartUpsellTotem() {
  const goTo = useGoTo();
  const { title, suggestions } = useCartUpsell({ canQuickAdd: noQuickAdd });

  if (!suggestions.length) {
    return null;
  }

  return (
    <section className="totem-upsell" aria-labelledby="totem-upsell-title">
      <h2 id="totem-upsell-title" className="totem-upsell__title">
        {title}
      </h2>
      <ul className="totem-upsell__track">
        {suggestions.map((product) => (
          <li key={product.id} className="totem-upsell__cell">
            <UpsellCardTotem
              product={product}
              onSelect={() => goTo(`/product/${product.id}`, { upsell: true })}
            />
          </li>
        ))}
      </ul>
    </section>
  );
}

function UpsellCardTotem({ product, onSelect }) {
  return (
    <div
      className="totem-upsell-card"
      role="button"
      tabIndex={0}
      aria-label={`Adicionar ${product.name}`}
      onClick={onSelect}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onSelect();
        }
      }}
    >
      {/* sem foto, um bloco neutro: os cartões lado a lado ficam alinhados */}
      <div className="totem-upsell-card__media">
        {product.pictureUrl ? (
          <img
            loading="lazy"
            decoding="async"
            src={product.pictureUrl}
            alt=""
            className="totem-upsell-card__img"
          />
        ) : (
          <span className="totem-upsell-card__placeholder">
            <RestaurantIcon />
          </span>
        )}
      </div>
      <div className="totem-upsell-card__body">
        <ProductName product={product} />
        <div className="totem-upsell-card__footer">
          <ProductPrice product={product} />
          <span className="totem-upsell-card__add btn-shop" aria-hidden="true">
            <AddIcon />
          </span>
        </div>
      </div>
    </div>
  );
}
